import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import axios from 'axios';
import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Dialog,
    DialogActions,
    DialogTitle,
    Grid,
    Paper,
    Typography,
} from "@mui/material";
import {useTheme} from "@mui/material/styles";

import get from "lodash.get";
import clonedeep from "lodash.clonedeep";
import Header from "../components/core/Header";
import {
    changeClaimStatus, fetchEnvMetaData, getcategoryList,
    getMetaDataList,
    getTariffDetails,
    markInsurerFinal,
    saveEditedTariff,
    updateTariffPackageView,
    viewClaim,
} from "../utils/API";
import Iframe from "../components/core/IFrame";
import PDFViewer from "../components/PDFViewer";
import moment from "moment";
import ReRunClaim from "../components/ReRunClaim";
import EditClaim from "../components/EditClaim";
import PMLTab from "../components/viewClaim/PMLTab";
import TariffTab from "../components/viewClaim/TariffTab";
import {readPackageInfo} from "../components/viewClaim/PackageConstruct";
import SummaryTab from "../components/viewClaim/SummaryTab";
import TabHeader from "../components/viewClaim/TabHeader";
import {enhancementStatusChangeNameList, RevertNameList} from "../constants/RevertNameList";
import {BillSummaryColumn} from "../constants/BillSummaryColumn";
import {BillTotal} from "../constants/BillTotal";
import {TariffTableColumn} from "../constants/TariffTableColumn";
import {PMLTableColumn} from "../constants/PMLTableColumn";
import InfoCard from "../components/viewClaim/InfoCard";
import ViewClaimShimmerEffect from "../components/core/ViewClaimShimmerEffect";
import {showToast} from "../utils/tostr";
import VerticalTabs from "../components/viewClaim/ClaimDocument";
import ChangeDecision from "../components/viewClaim/ChangeDecision";
import {
    getLocalStorageHospitalCode,
    isAbhiInsurer,
    isAdminUser,
    isNotInsurerReadOnlyUser,
    isVitrayaInternalUser
} from "../constants/UserAuth";
import ValidationRules from "../components/core/validationRules";
import SelectComponent from "../components/core/SelectComponent";
import {EnvKeys, getEnvItem,} from "../utils/EnvMetaDataUtil";
import ClaimViewHeader from "../components/viewClaim/ClaimViewHeader";
import AuthorizationLetter from "../components/viewClaim/AuthorizationLetter";
import MedicalAdmissibility from "../components/viewClaim/MedicalAdmissibility";
import {getSTPTableData} from "../utils/API";

function ViewClaim() {
    const theme = useTheme();
    let {claimId} = useParams();
    const email = localStorage.getItem("email");
    const [showRevertButton, setShowRevertButton] = useState(false);
    const [showFailureButton, setShowFailureButton] = useState(false);
    const [tabValue, setTabValue] = useState("summary");
    const [claimData, setClaimData] = useState([]);
    const [PMLTableData, setPMLTableData] = useState([]);
    const [procedureData, setProcedureData] = useState([]);
    const [metaData, setMetaData] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openFailureDialog, setOpenFailureDialog] = useState(false);
    const [isSubmitAllow, setIsSubmitAllow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingTariff, setTariffLoading] = useState(false);
    const [error, setError] = useState("");
    const [errorClaim, setErrorClaim] = useState("");
    const [tariffData, setTariffData] = useState([]);
    const [dynamicConstruct, setDynamicConstruct] = useState(null);
    const [updatedRows, setUpdatedRows] = useState(new Set());
    const [addedRows, setAddedRows] = useState(new Set());
    const [deletedRows, setDeletedRows] = useState(new Set());
    const [errorTariff, setErrorTariff] = useState("");
    const [showProportional, setShowProportional] = useState(true);
    const [isTariffSaved, setIsTariffSaved] = useState(false)
    const [documents, setDocuments] = useState([])
    const [type, setRerunType] = useState("");
    const [open, setOpen] = React.useState(false);
    const [preFillData, setPreFillData] = useState(null);
    const [savetariffloading, setSaveTariffLoading] = useState(false);
    /**
     * Has the Procedure Construct panel written anything into `tariffData` since the last save?
     * The panel stages its decisions like any other edit, so by the time they reach the payload
     * they are indistinguishable from rows edited in the grid - this is the only record of where
     * they came from, and `tariff/update` carries it as `pc_updated`.
     *
     * It is tracked rather than passed at the call site because the two ways a decision reaches
     * the API are not the same press: Save & Adjudicate saves on its own, but a decision taken
     * in the panel and left staged goes out with the next Save Tariff. Both should be flagged.
     */
    const [pcUpdated, setPcUpdated] = useState(false);
    /**
     * ...and the other side of the same fact, read back off the tariff response: this claim's
     * Procedure Construct saving has already been realised, by whoever got here first. It is a
     * separate flag from `pcUpdated` on purpose - that one is what this session has staged and
     * is asking the API to record, this one is what the API already holds. Folding the two into
     * one would make every ordinary grid edit claim to be a Procedure Construct decision.
     */
    const [pcSavingRealized, setPcSavingRealized] = useState(false);
    // Package construct: null for a claim without a package, else which lines are shown and the package summary.
    const [packageInfo, setPackageInfo] = useState(null);
    const [switchingPackageView, setSwitchingPackageView] = useState(false);

    const getClaimDocuments = () => {
        axios({
            url: `/document/list/${claimId}`,
            baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/su/support`,
            method: "GET",
            headers: {
                "X-Client-Platform": "CLAIM-ENHANCEMENT",
                "Content-Type": "blob",
                "X-Auth-Token": `${localStorage.getItem("authToken")}`,
            },
        })
            .then((response) => {
                let tempDocuments = get(response, ['data'], []).filter(item => {
                        if (
                            ['DISCHARGE', 'DISCHARGE_QUERY'].includes(get(item, ['stage'], ''))
                        ) {
                            return true
                        } else if (claimData?.coverCode === "DCTT") {
                            if (["PRE_AUTHORISATION_RAISED", "PRE_AUTHORISATION_RESPONSE_SENT"].includes(claimData?.claimStatus) && ['PRE_AUTH', 'PRE_AUTH_QUERY'].includes(get(item, ['stage'], ''))) {
                                return true
                            } else if (["INTERIM_RAISED", "INTERIM_RESPONSE_SENT"].includes(claimData?.claimStatus) && ['INTERIM', 'INTERIM_QUERY'].includes(get(item, ['stage'], ''))) {
                                return true
                            }
                        }
                        return false
                    }
                )
                tempDocuments.push({
                    "fileName": "No Bill File",
                    "preSingedURL": "",
                    "dateCreated": "",
                    "stage": "DISCHARGE"
                })
                setDocuments(tempDocuments)
            })
            .catch((error) => {
                console.error(error.message);
            });
    }

  const clearAddedRows = () => {
    // setAddedRows(null);
    setAddedRows(new Set());
  }

    const saveTariff = async () => {
        try {
            setSaveTariffLoading(true)
            const editedLines = tariffData.filter(obj => updatedRows.has(obj.row_id))
            const addedLines = tariffData.filter(obj => addedRows.has(obj.row_id))
            const deletedLines = [...deletedRows];
            await saveEditedTariff(claimId, email, editedLines, addedLines, claimData?.intimationNumber, deletedLines, pcUpdated)
            await fetchData()
            showToast('Tariff Saved Successfully', 'success', 'save-success')
            setIsTariffSaved(true)
            setUpdatedRows(new Set())
            // Cleared only on the way out of a save that worked. A failed one leaves the rows
            // staged, so the flag has to stay with them or the retry would go out unflagged.
            //
            // A save that carried the flag has just made the API hold it, so the panel is told
            // as much here rather than waiting on the next tariff fetch to say so.
            if (pcUpdated) {
                setPcSavingRealized(true)
            }
            setPcUpdated(false)
            clearAddedRows();
        } catch (e) {
            showToast('Tariff Saving Failed', 'error', 'save-failure')
        }finally {
            setSaveTariffLoading(false)
        }
    }

    useEffect(() => {
        if (addedRows.size + updatedRows.size + deletedRows.size > 0) {
            setIsTariffSaved(false)
        }
    }, [addedRows, updatedRows, deletedRows])

    /*const deleteRowIdsByRowId = useMemo((rowId) => {
      console.log('In delete method');
      let tempTariffData = clonedeep(tariffData)
      tempTariffData = tempTariffData.filter(item => get(item, ['row_id']) !== rowId)
      setTariffData(tempTariffData)
      let tempAddedRows = clonedeep(addedRows)
      tempAddedRows.delete(rowId)
      setAddedRows(tempAddedRows)<Auto
    }, [setTariffData]);*/

    const deleteRowIdsByRowId = (rowId) => {
        let tempDeletedTariffData = clonedeep(tariffData)
        tempDeletedTariffData = tempDeletedTariffData.filter(item => get(item, ['row_id']) === rowId)
        setDeletedRows(new Set([...deletedRows, tempDeletedTariffData[0]]));

        let tempTariffData = clonedeep(tariffData)
        tempTariffData = tempTariffData.filter(item => get(item, ['row_id']) !== rowId)
        setTariffData(tempTariffData)
        let tempAddedRows = clonedeep(addedRows)
        tempAddedRows.delete(rowId)

        setAddedRows(tempAddedRows)
    }


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const billLoginUrl = process.env.bill_Login_URL;
    // Old flow only (vneuronOldFlow: true) - the new flow renders MedicalAdmissibility instead
    const vNeuronLoginUrl = process.env.vNeuron_Login_URL;
    let FilterTariffTableColumn = [];
    let FilteredPMLTableColumn = [];

    if (!isVitrayaInternalUser()) {
        FilterTariffTableColumn = TariffTableColumn.filter(
            (x) =>
                x.title !== "Tariff Application Text" &&
                !x.title.hasOwnProperty("$$typeof")
        );
    }
    // if (!showProportional) {
    //   FilteredPMLTableColumn = PMLTableColumn.filter(
    //     (x) =>
    //       x.title !== "Room Proportional Discount" &&
    //       x.title !== "Amount After Room Proportional Discount"
    //   );
    // }
    useEffect(() => {
        const isShow = RevertNameList.some((str) => email.toLowerCase().includes(str.toLowerCase()));
        setShowRevertButton(isShow);
        const showFailureButton = enhancementStatusChangeNameList.some((str) => email.toLowerCase().includes(str.toLowerCase()));
        setShowFailureButton(showFailureButton);
        // fetchcategory();
        fetchMetaData();
        fetchData();
    }, []);
    useEffect(() => {
        getClaimDocuments()
    }, [claimData])
    useEffect(() => {
        refresh === true && window.location.reload();
    }, [refresh]);
    useEffect(() => {
        tabValue === "tariff" && fetchTariffData();        
    }, [tabValue]);

   useEffect(() => {
    if (tabValue !== "stp_details") return;

    getSTPTableData(claimId).then(data => {       
        const responseData = data?.data || {};       
        if (claimData?.claimStatus === "DISCHARGE_RESPONSE_SENT") {
            const formattedArray = Object.keys(responseData)
                .filter(key => key !== "preAuthFormResults") // exclude nested array
                .map(key => ({
                    fieldName: key,
                    preAuthDocValue: responseData[key]
                }));  
                setValidationRules(formattedArray);
        } else if ( responseData?.preAuthFormResults == null && claimData?.claimStatus === "PRE_AUTHORISATION_RESPONSE_SENT" ) {
            setIsCheckPreAuth(true);
            const formattedArray = Object.keys(responseData)
                .filter(key => key !== "preAuthFormResults") 
                .map(key => ({
                    fieldName: key,
                    preAuthDocValue: responseData[key]
                }));  
                setValidationRules(formattedArray);
        }       
        else {
            setIsCheckPreAuth(false);
            setValidationRules(responseData?.preAuthFormResults || []);
        }
    });
}, [tabValue, claimData?.claimStatus]);

    useEffect(() => {
    }, []);
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        // Opening the vNeuron tab closes the claim info accordion to give it room
        if (newValue === "vNeuron") setInfoExpanded(false);
    };

    const fetchData = async () => {
        setLoading(true);
        const fetchData = await viewClaim(claimId);
        if (fetchData?.success === false) {
            setErrorClaim(fetchData?.message?.text);
            setLoading(false);
        } else {
            setClaimData(clonedeep(fetchData));
            setPMLTableData(fetchData?.tariffPmlDataMerged?.billTariffPmlAmountList);
            // setShowProportional(
            //   fetchData?.tariffPmlDataMerged?.roomProportionalDiscountNonZero
            // );
            setLoading(false);
        }
    };
    const fetchMetaData = async (props) => {
        const response = await getMetaDataList(true);
        // setProcedureData(metaData.data["procedureList"]);
        const updatedResponseData = {
            ...response.data, // Keep all other properties of response.data
        //     medicalEventList: metaData.data.medicalEventList.map(event => ({
        //         id: event.name, // Replace id with name
        //         name: event.name, // Keep the name field unchanged
        //     })),
        };
        // console.log("this is the resposne", response)
        setMetaData(updatedResponseData);
        // console.log("this is actual data", metaData)
        // console.log("this should be metadata", get(metaData, ['categoryList', 0], {}))
    };
    const fetchcategory = async (props) => {
        const metaData = await getcategoryList();
        setMetaData(metaData);
    };

    const fetchTariffData = async () => {
        setTariffLoading(true);
        const response = await getTariffDetails(claimId);
        if (response.success) {
            // The tariff response now wraps the rows in an object alongside the claim id and the
            // dynamic construct - the line items are `data.line_items_list`. An array straight
            // off `data` is the older shape and still reads correctly.
            const lineItems = Array.isArray(response.data)
                ? response.data
                : get(response, ['data', 'line_items_list'], []);
            setTariffData(lineItems);
            setDynamicConstruct(get(response, ['data', 'dynamic_construct'], null));
            setPcSavingRealized(Boolean(get(response, ['data', 'pc_updated'], false)));
            setPackageInfo(Array.isArray(response.data) ? null : readPackageInfo(response.data));
            setTariffLoading(false);
        } else {
            setErrorTariff(response?.message?.text);
            setTariffLoading(false);
        }
    };
    // Switch a package claim between its package-applied lines and its original tariff lines. The backend
    // makes the chosen lines the claim's tariff (amounts, PML), so staged edits are dropped and both the
    // tariff and the claim are read back.
    const switchPackageView = async (packageView) => {
        try {
            setSwitchingPackageView(true);
            const response = await updateTariffPackageView(claimId, email, claimData?.intimationNumber, packageView);
            setTariffData(get(response, ['data', 'line_items_list'], []));
            setDynamicConstruct(get(response, ['data', 'dynamic_construct'], null));
            setPcSavingRealized(Boolean(get(response, ['data', 'pc_updated'], false)));
            setPackageInfo(readPackageInfo(response.data));
            setUpdatedRows(new Set());
            setAddedRows(new Set());
            setDeletedRows(new Set());
            setPcUpdated(false);
            showToast(packageView ? 'Switched to package applied lines' : 'Switched to original tariff lines', 'success', 'package-view-success');
            // claim amounts changed with the switch
            fetchData().catch(() => {});
        } catch (e) {
            showToast('Switching tariff lines failed', 'error', 'package-view-failure');
        } finally {
            setSwitchingPackageView(false);
        }
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setOpenFailureDialog(false)
    };
    const handleMarkItHasFinal = async () => {
        setLoading(true);
        const response = await markInsurerFinal(claimData.id, true);

        if (response.success) {
            setOpenDialog(false);
            setRefresh(true);
        } else {
            setError(response?.message.text || response?.data);
        }

        setLoading(false);
    };
    const handleRevertMrkItHasFinal = async () => {
        setLoading(true);

        const response = await markInsurerFinal(claimData.id, false);

        if (response.success) {
            setOpenDialog(false);
            setRefresh(true);
        } else {
            setError(response.message.text);
        }

        setLoading(false);
    };
    const getEnhancementStatuses = () => {
        return [
            {id: "ENHANCEMENT_IN_PROGRESS", name: "In Progress"},
            {id: "ENHANCEMENT_SUCCESSFUL", name: "Successful"},
            {id: "ENHANCEMENT_FAILED", name: "Failed"}
        ];
    };
    const setEnhancementStatuses = (props) => {
        if (props.id && props.type) {
            setRerunType(props.type);
            setIsSubmitAllow(true);
            console.log(props.id, props.type);
            // await rerunClaim({ claimId: props.id, claimFlow: props.type });
        }
    };
    const handleChangeClaimStatus = async () => {
        console.log()
        setLoading(true);
        const response = await changeClaimStatus(claimData.id, type);
        if (response?.success) {
            setOpenFailureDialog(false);
            setRefresh(true);
        } else {
            setError(response?.message?.text);
        }
        setLoading(false);
    };
     const [validationRules, setValidationRules] = useState([]);
     const [isCheckPreAuth, setIsCheckPreAuth] = useState(false);
    //TO Disable Cache for iframe
    const randomTimestamp = Date.now();
    // const vNeuronIframeSrc = `${process.env.REACT_APP_vNeuron_Frontend_URL}/?iframeauthenticate?random=${randomTimestamp}`;
    const vNeuronIframeSrc = `${getEnvItem(EnvKeys.vneuronFrontendUrl)}/?iframeauthenticate?random=${randomTimestamp}`;
    const billIframeSrc = `${getEnvItem(EnvKeys.billFrontendUrl)}/iframe?random=${randomTimestamp}`;
    // const billIframeSrc = `${process.env.REACT_APP_bill_Frontend_URL}/iframe?random=${randomTimestamp}`;

    function formatDate(dateString) {
        const date = new Date(dateString);

        // Pad single digit day and month with leading zeros
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
        const year = date.getFullYear();

        // Get hours and minutes
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

    // Return formatted date string
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const addedRowIds = new Set(Array.from(addedRows).map((item) => item.row_id));
  // console.log("Added RowId set parse",addedRowIds);

    const [claimView, setClaimView] = useState(true);
    const [infoExpanded, setInfoExpanded] = useState(true);


  // Handle toggle for validation rule approval
  const handleToggleApproval = (index) => {
    setValidationRules((prevRules) =>
      prevRules.map((rule, i) =>
        i === index ? { ...rule, approved: !rule.approved } : rule
      )
    );
  };

  // Handle submit validation rules
  const handleSubmitValidationRules = () => {
    const updatedRules = validationRules.map((rule) => ({
      ...rule,
      status: rule.approved ? "PASS" : "QUERY",
    }));
    console.log("Submitting validation rules:", updatedRules);
    // You can add API call here to submit the rules
    alert("Validation rules submitted successfully!");
  };


    return (
        <Box
            sx={{
                background: theme.palette.background.default,
                minHeight: "100vh",
            }}
        >
            <Header/>
            {errorClaim === "" && loading === false && (
                <Container maxWidth={"false"}>
                    <Card
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "space-between",
                            padding: 5,
                            marginTop: "5px",
                        }}
                    >
                        <Grid
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                // marginLeft: "10px",
                                margin: "6px",
                                // gap: 25,
                            }}
                        >
                            <Typography
                                variant="subTitle1"
                                component={"h4"}
                                sx={{
                                    color: "#B1B3B3",
                                    marginTop: "5px",
                                    fontSize: "15px",
                                }}
                            >
                                Claim Intimation Number :{" "}
                                <span style={{color: "#000"}}>
                  {get(claimData, ["intimationNumber"], `Not found`)}
                </span>
                            </Typography>
                            {
                                isAbhiInsurer() &&
                                <>
                                    <Typography
                                        variant="subTitle1"
                                        component={"h4"}
                                        sx={{
                                            color: "#B1B3B3",
                                            marginTop: "5px",
                                            marginLeft: '12px',
                                            fontSize: "15px",
                                        }}
                                    >
                                        Policy Number :{" "}
                                        <span style={{color: "#B1B3B3"}}>
                      {get(claimData, ["policyNumber"], `Not found`)}
                    </span>
                                    </Typography>
                                    <Typography
                                        variant="subTitle1"
                                        component={"h4"}
                                        sx={{
                                            color: "#B1B3B3",
                                            marginTop: "5px",
                                            marginLeft: '12px',
                                            fontSize: "15px",
                                        }}
                                    >
                                        Date of Admission :{" "}
                                        <span style={{color: "#B1B3B3"}}>
                      {moment(claimData?.dateOfAdmission).format(
                          "DD-MM-YYYY, h:mm a"
                      )}
                    </span>
                                    </Typography>
                                    <Typography
                                        variant="subTitle1"
                                        component={"h4"}
                                        sx={{
                                            color: "#B1B3B3",
                                            marginTop: "5px",
                                            marginLeft: '12px',
                                            fontSize: "15px",
                                        }}
                                    >
                                        Date of Discharge :{" "}
                                        <span style={{color: "#B1B3B3"}}>
                      {moment(claimData?.dateOfDischarge).format(
                          "DD-MM-YYYY, h:mm a"
                      )}
                    </span>
                                    </Typography>
                                </>
                            }
                        </Grid>
                        {isVitrayaInternalUser() && (
                            <Grid
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                    padding: 5,
                                    gap: 25,
                                }}
                            >
                                {
                                    isAdminUser() && <ReRunClaim
                                        claimId={claimData.id}
                                        corporateCode={getLocalStorageHospitalCode()}
                                        setRefresh={setRefresh}
                                        disabled={
                                            claimData?.combinedStatus === "ENHANCEMENT_IN_PROGRESS" || claimData.insurerVisible
                                                ? true
                                                : false
                                        }
                                        enablerestartocr={get(claimData, ['enableReStartCOCR'], '')}
                                    />
                                }
                                <EditClaim
                                    // procedureList={procedureData}
                                    hospitalId={claimData?.hospitalId}
                                    // roomList={metaData.hospitalServiceList}
                                    // pedList={metaData?.illnessList || []}
                                    claimStatus={get(claimData, ['claimStatus'], '')}
                                    coverCode={get(claimData, ['coverCode'], '')}
                                    // pedList={['sdf', 'sdfdf']}
                                    treatmentList={[
                                        {id: "SURGICAL", name: "Surgical"},
                                        {id: "MEDICAL", name: "Medical"},
                                    ]}
                                    // reasonsForHospitalisation={metaData?.medicalEventList || []}
                                    selectedProcedure={{
                                        id: claimData.procedureId,
                                        name: claimData.procedureName,
                                    }}
                                    selectedRoomType={claimData?.roomType}
                                    selectedTreatmentType={claimData?.treatmentType}
                                    selectedIllnessType={claimData?.illnessId}
                                    selectedsecondaryIllnessType={claimData?.secondaryIllnessId}
                                    selectedtertiaryIllnessType={claimData?.tertiaryIllnessId}
                                    selectedReasonForHospitalization={claimData?.reasonForHospitalization}
                                    selectedPEDList={claimData?.pedList}
                                    claimId={claimData.id}
                                    claimPedList={claimData?.pedList || []}
                                    disabled={claimData.insurerVisible}
                                    documents={documents}
                                    selectedUnDisclosedPedType={claimData?.unDisclosedPEDId}
                                    selectedUnDisclosedPedDuration={claimData?.unDisClosedPEDuration}
                                    gplavalue={claimData?.gpla}
                                />
                                {isAdminUser() &&
                                    <Button
                                        variant="contained"
                                        onClick={() => setOpenDialog(true)}
                                        disabled={claimData.insurerVisible}
                                    >
                                        {claimData.insurerVisible
                                            ? "Marked to insurer final"
                                            : "Mark Insurer Final"}
                                    </Button>
                                }
                                {/* <Button
                      variant="contained"
                      onClick={handleRevertMrkItHasFinal}
                    >
                      Revert Insurer Final
                    </Button> */}

                                {claimData.insurerVisible === true
                                    && isAdminUser() &&
                                    showRevertButton === true && (
                                        <Button
                                            variant="contained"
                                            onClick={handleRevertMrkItHasFinal}
                                        >
                                            Revert Insurer Final
                                        </Button>
                                    )
                                }
                                {isAdminUser() &&
                                    showFailureButton === true && (
                                        <Button
                                            variant="contained"
                                            onClick={() => setOpenFailureDialog(true)}
                                        >
                                            Update Enhancement Status
                                        </Button>
                                    )
                                }
                            </Grid>
                        )}
                    </Card>


                    <Grid style={{marginTop: "20px"}}>
                        {/* Claim Informations */}
                        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                            <ClaimViewHeader
                                viewClaim={claimView}
                                setClaimView={setClaimView}
                                claimData={claimData}
                                infoExpanded={infoExpanded}
                                setInfoExpanded={setInfoExpanded}
                            >
                                {/* The accordion body - vNeuron closes it via infoExpanded */}
                                {claimView && <InfoCard claimData={claimData}/>}
                            </ClaimViewHeader>
                        </Box>
                        {/* {
                            !claimView && <STPTable claimDataId={claimId}/>
                        } */}

                        <Grid item>
                            {/* Tabs Headers */}
                            <Paper
                                elevation={3}
                                style={{marginTop: "10px", marginBottom: "10px"}}
                            >
                                <TabHeader
                                    tabValue={tabValue}
                                    handleChange={handleChange}
                                    claimData={claimData}
                                    PMLTableData={PMLTableData}
                                />
                            </Paper>
                            {/* Tabs Section */}
                            {tabValue === "summary" && (
                                <SummaryTab
                                    claimData={claimData}
                                    billSummaryColumn={BillSummaryColumn}
                                    billTotal={BillTotal}
                                />
                            )}
                            {tabValue === "pml" && (
                                <PMLTab
                                    claimData={claimData}
                                    PMLTableColumn={
                                        FilteredPMLTableColumn.length === 0
                                            ? PMLTableColumn
                                            : FilteredPMLTableColumn
                                    }
                                    showProportional={showProportional}
                                />
                            )}
                            {tabValue === "vNeuron" && (
                                <Box>
                                    {isNotInsurerReadOnlyUser() &&
                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}>
                                            <ChangeDecision
                                                claimId={claimId}
                                                claimNumber={claimData.intimationNumber}
                                                adjudicationStatus={claimData?.adjudicationStatus}/>
                                        </Box>}
                                    {/*
                                      * vneuronOldFlow: true  -> the old vNeuron iframe; the vneuron API is not called.
                                      * vneuronOldFlow: false -> the Medical Admissibility screen. It is mounted only
                                      * while this tab is open, so it fetches claim/{insurerClaimIdentifier}/vneuron
                                      * on the click that opens the tab.
                                      */}
                                    {claimData?.vneuronOldFlow === true ? (
                                        <>
                                            {claimData?.medicalIdentifier !== null &&
                                                <Iframe
                                                    src={vNeuronIframeSrc}
                                                    siteName="vNeuron"
                                                    id={get(
                                                        claimData,
                                                        ["medicalIdentifier"],
                                                        `20230802-3F665423`
                                                    )}
                                                    serverUrl={vNeuronLoginUrl}
                                                />
                                            }
                                            {claimData?.medicalIdentifier === null &&
                                                <Card sx={{mt: '1rem', minWidth: 275}}>
                                                    <CardContent>
                                                        <Typography
                                                            sx={{
                                                                fontSize: 20,
                                                                fontWeight: 900,
                                                                fontFamily: '"Nunito", sans-serif',
                                                            }}
                                                            gutterBottom
                                                        >
                                                            Medical Admissibility :
                                                        </Typography>
                                                        <Typography variant="h5" component="div"></Typography>

                                                        <Grid style={{display: "flex", gap: 30}}>
                                                            <Typography variant="subTitle1" component={"p"}>
                                                                Comment :
                                                            </Typography>
                                                            <Typography variant="subTitle1" component={"p"}>
                                                                Medical Admissibility not applicable
                                                            </Typography>
                                                        </Grid>
                                                        <Grid style={{display: "flex", gap: 70}}>
                                                            <Typography variant="subtitle2" component={"p"}>
                                                                Note :
                                                            </Typography>
                                                            <Typography variant="subtitle2" component={"p"}>
                                                                {claimData["vneuronRemarks"] !== undefined && claimData["vneuronRemarks"] !== null
                                                                    ? claimData["vneuronRemarks"]
                                                                    : "At initial stage medical admissibility will only run for Daycare Treatments"}
                                                            </Typography>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            }
                                        </>
                                    ) : (
                                        <MedicalAdmissibility
                                            claimId={claimId}
                                            insurerClaimIdentifier={claimData?.insurerClaimIdentifier}
                                            definedProcedure={claimData}/>
                                    )}
                                </Box>
                            )}
                            {tabValue === "bill" && (
                                <Box>
                                    <Iframe
                                        src={billIframeSrc}
                                        siteName="bill"
                                        id={get(claimData, ["billIdentifier"], `659525`)}
                                        serverUrl={billLoginUrl}
                                    />
                                </Box>
                            )}
                            {tabValue === "tariff" && (
                                <TariffTab
                                    metaData={metaData}
                                    claimData={claimData}
                                    claimId={claimId}
                                    errorTariff={errorTariff}
                                    loadingTariff={loadingTariff}
                                    tariffTableColumn={
                                        FilterTariffTableColumn.length === 0
                                            ? TariffTableColumn
                                            : FilterTariffTableColumn
                                    }
                                    tariffData={tariffData}
                                    dynamicConstruct={dynamicConstruct}
                                    setTariffData={setTariffData}
                                    setUpdatedRows={setUpdatedRows}
                                    setPcUpdated={setPcUpdated}
                                    pcSavingRealized={pcSavingRealized}
                                    setAddedRows={setAddedRows}
                                    saveTariff={saveTariff}
                                    handleClickOpen={handleClickOpen}
                                    handleClose={handleClose}
                                    open={open}
                                    addedRowIds={addedRows}
                                    updatedRows={updatedRows}
                                    deletedRows={deletedRows}
                                    deleteRowIdsByRowId={deleteRowIdsByRowId}
                                    isTariffSaved={isTariffSaved}
                                    preFillData={preFillData}
                                    setPreFillData = {setPreFillData}
                                    isLoading={savetariffloading}
                                    packageInfo={packageInfo}
                                    onSwitchPackageView={switchPackageView}
                                    switchingPackageView={switchingPackageView}
                                />
                            )}
                            {tabValue === "documents" && <PDFViewer id={claimId} isTxnLetter/>}
                            {tabValue === "claim_documents" && <VerticalTabs id={claimId} files={documents}/>}
                              {tabValue === "stp_details" && 
                              
                                <ValidationRules
                                                  validationRules={validationRules}
                                                  onToggleApproval={handleToggleApproval}
                                                  onSubmitRules={handleSubmitValidationRules}
                                                  disabled={true}
                                                  isShowForDischarge={claimData?.claimStatus == "DISCHARGE_RESPONSE_SENT" || isCheckPreAuth}
                                                  isShowSTPData={true}
                                                  showSubmitButton={false}
                                                />}
                            {tabValue === "auth_letter" && (
                                <AuthorizationLetter claimData={claimData} claimId={claimId}/>
                            )}
                        </Grid>

                        <Dialog open={openDialog} onClose={handleCloseDialog}>
                            <DialogTitle>
                                Do you approve this claim can be sent to insurer ?{" "}
                            </DialogTitle>
                            <p>{error}</p>
                            <DialogActions>
                                <Button
                                    variant="contained"
                                    onClick={handleMarkItHasFinal}
                                    disabled={loading}
                                >
                                    yes
                                </Button>
                                <Button varient="outlined" onClick={handleCloseDialog}>
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={openFailureDialog} onClose={handleCloseDialog}>
                            <DialogTitle>
                                Select new claim enhancement status:{" "}
                                <SelectComponent
                                    label={"Claim Enhancement Status"}
                                    menuItem={getEnhancementStatuses()}
                                    setSelections={(type) =>
                                        setEnhancementStatuses({
                                            type: type,
                                            id: claimId
                                        })
                                    }
                                    style={{margin: 0}}
                                />
                            </DialogTitle>
                            <p>{error}</p>
                            <DialogActions>
                                <Button
                                    variant="contained"
                                    onClick={handleChangeClaimStatus}
                                    disabled={loading || !isSubmitAllow}>
                                    Submit
                                </Button>
                                <Button varient="outlined" onClick={handleCloseDialog}>
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>

                </Container>
            )}
            {
                errorClaim !== "" && (
                    <Container maxWidth="xl" style={{textAlign: "center", padding: 40}}>
                        <p style={{color: "red"}}>{errorClaim}</p>
                    </Container>
                )
            }
            {
                loading === true && <ViewClaimShimmerEffect/>
            }
        </Box>)
        ;
}

export default ViewClaim;
